// Adds Tailwind variables to the global scope
import "./setup/tailwind-setup.js";

// Import JavaScript components
// import './components/accordion';
// import './components/tabs';
// import './components/toggle';

//If you want cookie consent
// import "./modules/cookie-consent";

//If you need a class to be toggled on a different element
// import "./modules/toggle";

//If you need to do something when its in/out of the viewport
// import "./modules/intersects";

/** Featured menu sub-menu scrollbars */
document.querySelectorAll(".group\\/featured-menu")?.forEach((menu) => {
	menu.querySelectorAll(".sub-menu")?.forEach((sub_menu) => {
		sub_menu.addEventListener("transitionstart", (event) => {
			if (event instanceof TransitionEvent && event.propertyName === "max-height") {
				sub_menu.classList.remove("!overflow-y-auto");
			}
		});
		sub_menu.addEventListener("transitionend", (event) => {
			if (event instanceof TransitionEvent && event.propertyName === "max-height") {
				sub_menu.classList.add("!overflow-y-auto");
			}
		});
	});
});

{
	const html = document.querySelector("html");
	if (html instanceof HTMLElement) {
		/** Main menu button */
		{
			const main_menu_button = document.querySelector("#main-menu-button");
			if (main_menu_button instanceof HTMLElement) {
				main_menu_button.addEventListener("click", (_) => {
					html.classList.toggle("main-menu-active");
				});
			}
			const main_menu = document.querySelector("#main-menu");
			if (main_menu instanceof HTMLElement) {
				html.addEventListener("click", (event) => {
					const target = event?.target;
					if (target instanceof HTMLElement && !main_menu_button.contains(target) && !main_menu.contains(target)) {
						html.classList.remove("main-menu-active");
					}
				});
			}
		}

		/** Toggles */
		{
			const toggle_containers = document.querySelectorAll(".toggle-container");
			toggle_containers.forEach((toggle_container) => {
				if (toggle_container instanceof Element) {
					const toggle = toggle_container.querySelector(".toggle");
					if (toggle instanceof Element) {
						toggle.addEventListener("click", (_) => {
							if (!toggle.classList.contains("active")) {
								toggle.classList.add("active");
							} else {
								toggle.classList.remove("active");
							}
						});
						html.addEventListener("click", (event) => {
							const target = event?.target;
							if (target instanceof Element && !toggle_container.contains(target)) {
								toggle.classList.remove("active");
							}
						});
					}
				}
			});
		}
	}
}
